import axios from "axios";

export const state = {
    payoutrequests: [],
};

export const getters = {
    payoutrequests: state => state.payoutrequests,
};

export const mutations = {
    setPayoutRequests(state, newValue) {
        state.payoutrequests = newValue
    },
};

export const actions = {
    async fetchPayoutRequests({ commit }) {
        await axios.get('/payout-requests').then(res => {
            commit('setPayoutRequests', res.data.payout_requests)
        })
    },
};
